import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';

/**
 * EstimatedRentalValue Widget
 */
@Component({
  selector: 'estimated-rental-value-widget',
  templateUrl: './estimated-rental-value-widget.component.html',
  styleUrls: ['./estimated-rental-value-widget.component.scss', '../../common/css/general.scss']
})
export class EstimatedRentalValueWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("estimatedRentalValue", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {

    this.mockupData$ = this.widgetService.loadMockup('estimatedRentalValue').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('estimatedRentalValue', this.getReport()).pipe();
  }

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'estimatedRentalValue', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    try {
      for (const erv of data.estimatedRentalValues) {
        //Data in DB is per year. Convert to per month for UI
        if (erv.displayValuesOverTimeId == 2) {
          erv.reportValuationMarketERVFrom /= 12;
          erv.reportValuationMarketERVTo /= 12;
        }
      }
    } catch (e) {
      //Ignore
    }
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    try {
      for (const erv of data.estimatedRentalValues) {
        //Data in DB is per year. Convert from per month for saving
        if (erv.displayValuesOverTimeId == 2) {
          erv.reportValuationMarketERVFrom *= 12;
          erv.reportValuationMarketERVTo *= 12;
        }
      }
    } catch (e) {
      //Ignore
    }
    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Change current widget layout
  * @param event Event object
   */
  private changeCurrentLayout(event: any): void {
    this.currentLayout = event;
  }
}
